<mat-form-field [appearance]="appearance || 'legacy'" class="w-full">
  <mat-label>{{ label }}</mat-label>
  <div class="color" [ngStyle]="{ 'background-color': '#' + ngControl?.control.value }"></div>
  <input
    class="ml-8 input"
    type="text"
    matInput
    fbDisableAutocomplete
    mask="CCCCCC"
    prefix="#"
    [patterns]="patterns"
    [formControl]="ngControl?.control"
    [placeholder]="placeholder"
    [required]="required"
    [fbDisableControl]="disable"
    [readonly]="readonly"
    (focusout)="onTouched()"
  />
</mat-form-field>
